<template>
  <tr @click="toggleIndividualContact()" style="height: 43px;">
    <td>{{ rowNumber }}</td>
    <td>{{ formatDate(contact.sentDate) }}</td>
    <td>{{ contact.receiver.last_name }} {{ contact.receiver.name }}</td>
    <td>{{ contact.jobDetail }}</td>
    <td>
      <span class="user-response" v-if="userResponse">{{ userResponse }}</span>
    </td>
    <td>{{ contact.sender || '' }}</td>
    <td style="text-align: center !important;">
      <div class="interview-container" @click.stop>
        <Interview
          :interview="contact.receiver.isInterview"
          @click.native="toggleInterview(contact.receiver)"
          :toggledisabledInt="loading"
        />

        <div class="interview-text">面接<br />実施</div>
      </div>
    </td>
    <IndividualContactModal
      v-if="showIndividualContact"
      :applicantIndex="index"
      :applicant_id="contact.receiver._id"
      :showIndividualContact="showIndividualContact"
      @cancel="toggleIndividualContact"
    />
  </tr>
</template>

<script>
import moment from 'moment';
import IndividualContactModal from '../IndividualContactModal.vue';
import Interview from '@/components/dashboard/applicants/Interview.vue';
import Api from '../../../../config/api';
import ApiService from '../../../../service/apiService';
import { mapMutations } from 'vuex';

export default {
  name: 'ReceivedContactRow',
  props: ['sentContact', 'index', 'rowNumber'],
  components: { IndividualContactModal, Interview },
  data() {
    return {
      contact: this.sentContact,
      loading: false,
      showIndividualContact: false,
    };
  },
  computed: {
    userResponse() {
      if (this.contact.contactDetail == 'その他通知') {
        return '通知のみ';
      }
      return this.contact.user_response;
    },
  },
  methods: {
    ...mapMutations(['mutateSentListAfterInterview']),
    toggleIndividualContact() {
      this.showIndividualContact = !this.showIndividualContact;
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    openIndividualContact(applicant) {
      let routeUrl = this.$router.resolve({
        path: `/applicant/${applicant._id}/contact`,
      });
      // Open in a new tab
      window.open(routeUrl.href, '_blank');
    },
    toggleInterview(applicant) {
      this.loading = true;
      console.log('toggling interview');
      console.log(applicant);
      const method = applicant.isInterview ? 'delete' : 'put';
      ApiService[method](Api.endpoints.INTERVIEW(applicant._id))
        .then(({ data }) => {
          this.mutateSentListAfterInterview(data.data);
        })
        .catch((error) => console.log(error))
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.user-response {
  display: inline-block;
  width: 130px;
  height: 32px;
  border-radius: 3px;
  background: #787878;
  color: #fff;
  padding: 5px;
  text-align: center;
}

.green-tab {
  background-color: #5bb55b;
}

td {
  text-align: center !important;
  /* font-size: 12px !important; */
  color: #3c3c3c !important;
}

tr {
  cursor: pointer;
}

.interview-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}

.interview-text {
  font-size: 12px;
  color: #787878;
  font-weight: 400;
  line-height: 1.2;
  text-align: left;
}
</style>
